import { useSortable } from '@dnd-kit/sortable';
import React from 'react';
import { Box } from '@mui/material';

type DragHandleProps = {
  ref: (element: HTMLElement | null) => void;
} & React.DOMAttributes<HTMLElement>;

type Props = {
  id: string | number;
  children?: React.ReactNode | ((props: { dragHandleProps: DragHandleProps }) => React.ReactNode);
  isDragHandle?: boolean;
};

export const SortableItem = ({ id, children, isDragHandle = false }: Props) => {
  const { attributes, listeners, setNodeRef, setActivatorNodeRef, transform, transition, isDragging } = useSortable({
    id,
  });

  const dragHandleProps = isDragHandle ? {} : listeners;

  const renderChildren = () => {
    if (isDragHandle && typeof children === 'function') {
      return children({ dragHandleProps: { ref: setActivatorNodeRef, ...listeners } });
    }
    return children as React.ReactNode;
  };

  return (
    <Box
      ref={setNodeRef}
      data-id={id}
      sx={{
        transform: transform ? `translate3d(${transform.x}px, ${transform.y}px, 0)` : undefined,
        transition,
        opacity: isDragging ? 0.5 : 1,
        width: '100%',
      }}
      {...attributes}
      {...dragHandleProps}
    >
      {renderChildren()}
    </Box>
  );
};
